export function CrewPickerHint({ children, tone }: { children: React.ReactNode; tone?: 'warn' }) {
  return (
    <div
      style={{
        fontSize: 12,
        padding: '8px 4px',
        color: tone === 'warn' ? '#c0392b' : 'var(--nb-subtle)',
      }}
    >
      {children}
    </div>
  );
}
